import i18next from "i18next";
import React, { useMemo } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { appName as configAppName } from "../../config";

const Seo = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`seo.casino.${key}`, { ...props });

  // 根據當前網址判斷網站名稱
  const websiteName = useMemo(() => {
    const currentUrl = window.location.hostname;
    // 檢查網址是否包含 gd88
    if (currentUrl.includes("gd88")) {
      return "金仁娛樂城";
    }
    // 否則使用環境變數設定的網站名稱
    return configAppName;
  }, []);

  return process.env.REACT_APP_DEVELOP_MODE == 1 ? null : (
    <Helmet>
      <meta charSet="utf-8" />
      <meta property="og:description" content={websiteName} />
      <meta property="og:title" content={websiteName} />
      <meta property="og:url" content={`${window.location.origin}/slots`} />
      <link rel="canonical" href={`${window.location.origin}/slots`} />
      <title lang={i18next.language}>
        {i18n("title", { appName: websiteName })}
      </title>
      <meta
        lang={i18next.language}
        content={i18n("meta1", { appName: websiteName })}
      />{" "}
    </Helmet>
  );
};

export default Seo;
